export default __webpack_public_path__ + "static/media/cloud-kitchen.d6b0fa0b.svg";